import React, {FC, useState} from "react";
import { Input } from "@jane/lib/src/components/form/Input";
import {useApiCall} from "../../../lib/src/api";
import {useToasts} from "../../../lib/src/toasts/toasts";
import {config} from "../config";
import {CallbackRequestTemplate} from "../../../lib/src/api/repositories/telephone-repository";
import {Paragraph} from "../../../lib/src/components/Paragraph";
import {Card} from "../../../lib/src/components/Card";
import MDEditor from "@uiw/react-md-editor";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const EditCallbackTemplateModal: FC<{ callbackRequest: CallbackRequestTemplate, onFinished: () => void }> = (props) => {
  const { telephone } = useApiCall(config)
  const [name, setName] = useState<string>(props.callbackRequest.name ?? '')
  const [body, setBody] = useState<string>(props.callbackRequest.text ?? '')
  const {showToast} = useToasts()

  const submit = async () => {
    await telephone.editCallbackTemplate(props.callbackRequest.id, name, body).catch(() => {
      showToast('Oeps', 'Er is iets misgegaan bij het bewerken van een terugbel sjabloon.')
    })
    props.onFinished()
  }

  return <div className={'space-y-3'}>
    <Input label={'Naam'} type={'text'} value={name} onChange={setName} maxWidth={"full"} />
    <Card title={"Variabelen"}>
      <Paragraph>Gebruik onderstaande variabelen (inclusief haakjes) om tijdens het aanmaken automatisch een waarde te laten toevoegen</Paragraph>
      <table>
        <tbody>
        <tr>
          <td className={'font-mono text-xs pr-2'}>(telefoon)</td>
          <td className={'text-sm'}>Telefoonnummer van gesprek</td>
        </tr>
        <tr>
          <td className={'font-mono text-xs pr-2'}>(medewerker)</td>
          <td className={'text-sm'}>Medewerkersnaam welke het terugbelverzoek aanmaakt</td>
        </tr>
        <tr>
          <td className={'font-mono text-xs pr-2'}>(client)</td>
          <td className={'text-sm'}>Naam van de relevante cliënt</td>
        </tr>
        <tr>
          <td className={'font-mono text-xs pr-2'}>(clientnummer)</td>
          <td className={'text-sm'}>Cliëntnummer van de relevante cliënt</td>
        </tr>
        <tr>
          <td className={'font-mono text-xs pr-2'}>(team)</td>
          <td className={'text-sm'}>Teamnaam</td>
        </tr>
        </tbody>
      </table>
    </Card>
    <Input label={'Inhoud'} type={'markdown'} value={body} onChange={setBody} maxWidth={"full"} height={'64'} />
    <ModalFooter text={'Opslaan'} onSubmit={async () => {
      await submit()
      close()
    }} />
  </div>
}